import React from 'react';
import { Link } from 'react-router-dom';
import qs from 'qs';

interface Props {
    params: Record<string, string | number | boolean>;
}

const QueryStringLink = ({
    params,
    children
}: React.PropsWithChildren<Props>): React.ReactElement => (
    <Link
        to={{
            search: qs.stringify(params)
        }}
    >
        {children}
    </Link>
);

export default QueryStringLink;
